import { render, staticRenderFns } from "./GoogleClassroomCourses.vue?vue&type=template&id=46d9b766&scoped=true&"
import script from "./GoogleClassroomCourses.vue?vue&type=script&lang=ts&"
export * from "./GoogleClassroomCourses.vue?vue&type=script&lang=ts&"
import style0 from "./GoogleClassroomCourses.vue?vue&type=style&index=0&id=46d9b766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d9b766",
  null
  
)

export default component.exports